import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "my-recent-patients-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }
const _hoisted_4 = { class: "trezo-card-content" }
const _hoisted_5 = { class: "basic-table table-responsive" }
const _hoisted_6 = { class: "table mb-0" }
const _hoisted_7 = { class: "fw-semibold text-body" }
const _hoisted_8 = { class: "employee-info d-flex align-items-center" }
const _hoisted_9 = { class: "img rounded-circle" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "d-block fw-semibold" }
const _hoisted_12 = { class: "d-block text-body" }
const _hoisted_13 = { class: "fw-semibold text-body" }
const _hoisted_14 = { class: "fw-semibold text-body" }
const _hoisted_15 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap pt-3" }
const _hoisted_16 = { class: "fs-12 fw-medium" }
const _hoisted_17 = { "aria-label": "Page navigation example" }
const _hoisted_18 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_19 = { class: "page-item" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "page-item" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "mb-0" }, "My Recent Patients", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFilter) = $event)),
          class: "form-select month-select bg-gray border-0 form-control",
          "aria-label": "Default select example"
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("option", { value: "This Day" }, "This Day", -1),
          _createElementVNode("option", { value: "This Week" }, "This Week", -1),
          _createElementVNode("option", { value: "This Month" }, "This Month", -1),
          _createElementVNode("option", { value: "This Year" }, "This Year", -1)
        ]))], 512), [
          [_vModelSelect, _ctx.selectedFilter]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "ID"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Patient Name"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Disease"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Payment Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                })
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedPatients, (patient) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: patient.id
                }, [
                  _createElementVNode("td", _hoisted_7, "#" + _toDisplayString(patient.id), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: patient.image,
                          alt: "user-image",
                          class: "rounded-circle"
                        }, null, 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(patient.name), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(patient.email), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(patient.disease), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(patient.paymentStatus), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`trezo-badge ${patient.statusClass}`)
                    }, _toDisplayString(patient.status), 3)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "dropdown action-opt" }, [
                      _createElementVNode("button", {
                        class: "btn bg-transparent p-0",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "ri-more-2-fill" })
                      ]),
                      _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", { class: "dropdown-item" }, "View")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", { class: "dropdown-item" }, "Edit")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", { class: "dropdown-item" }, "Delete")
                        ])
                      ])
                    ])
                  ], -1))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, " Showing " + _toDisplayString(_ctx.startIndex + 1) + " to " + _toDisplayString(_ctx.endIndex) + " of " + _toDisplayString(_ctx.filteredPatients.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_17, [
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", _hoisted_19, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Previous",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_20)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_21)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Next",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_23)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}